import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import './CreateEmailLabelModal.css'

export const EMAIL_LABEL_COLOR_SWATCHES = [
  '#FE746B',
  '#ED9A5E',
  '#F5D565',
  '#9DD8AC',
  '#65ACF5',
  '#185DD8',
  '#B794F4',
  '#E57373',
  '#4A5568',
]

type CreateEmailLabelModalProps = {
  show: boolean
  onHide: () => void
  onCreate: (name: string, color: string) => void
}

function CreateEmailLabelModal({
  show,
  onHide,
  onCreate,
}: CreateEmailLabelModalProps): React.ReactElement {
  const [name, setName] = useState('')
  const [color, setColor] = useState(EMAIL_LABEL_COLOR_SWATCHES[0] ?? '#185DD8')

  useEffect(() => {
    if (!show) {
      setName('')
      setColor(EMAIL_LABEL_COLOR_SWATCHES[0] ?? '#185DD8')
    }
  }, [show])

  const handleCreate = (): void => {
    const next = name.trim()
    if (!next) return
    onCreate(next, color)
    onHide()
  }

  const canSubmit = name.trim().length > 0

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdropClassName="mce-create-label-modal-backdrop"
      dialogClassName="mce-create-label-modal-dialog"
      contentClassName="mce-create-label-modal-content"
    >
      <div className="mce-create-label-modal">
        <div className="mce-create-label-head">
          <h2 className="mce-create-label-title">Create label</h2>
          <button
            type="button"
            className="mce-create-label-close"
            aria-label="Close"
            onClick={onHide}
          >
            <i className="mgc mgc_close_line" aria-hidden />
          </button>
        </div>

        <div className="mce-create-label-body">
          <div className="mce-create-label-field">
            <label
              className="mce-create-label-label"
              htmlFor="mce-create-label-name"
            >
              Label name
            </label>
            <input
              id="mce-create-label-name"
              type="text"
              className="mce-create-label-input"
              placeholder="Enter label name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && canSubmit) {
                  e.preventDefault()
                  handleCreate()
                }
              }}
              autoComplete="off"
              autoFocus
            />
          </div>

          <div className="mce-create-label-field">
            <p className="mce-create-label-label">Label color</p>
            <div
              className="mce-create-label-swatches"
              role="listbox"
              aria-label="Label color"
            >
              {EMAIL_LABEL_COLOR_SWATCHES.map((hex) => (
                <button
                  key={hex}
                  type="button"
                  role="option"
                  aria-selected={color === hex}
                  className={`mce-create-label-swatch${color === hex ? ' mce-create-label-swatch--selected' : ''}`}
                  style={{ backgroundColor: hex }}
                  onClick={() => setColor(hex)}
                  title={hex}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mce-create-label-footer">
          <button
            type="button"
            className="mce-create-label-btn-cancel"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            type="button"
            className="mce-create-label-btn-create"
            onClick={handleCreate}
            disabled={!canSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default CreateEmailLabelModal
